import profileMdl from "./profile.mdl";

export default [...profileMdl];
